import { useState, useEffect } from "react"
import CustomizeModal from "./CustomizeModal.client"
import { CustomerAccount, CustomerMetafields, ImageItem, ProductFilterObject, ProductMetafields, ShopMetafields, ShopSettings, VariantEdgeMetafields } from "~/types"
import { CartDrawer } from "../../global/CartDrawer.client"
import { useDrawer } from "../../global/Drawer.client"
import { useCart } from "@shopify/hydrogen"
import { CartLineInput } from "@shopify/hydrogen/storefront-api-types"
import ProductsBreadcrumb from "../ProductsBreadcrumb.client"
import ZoomImageModal from "./ZoomImageModal.client"
import ProductImage from "./ProductImage.client"
import ProductInfo from "./ProductInfo.client"
import RecommendedProducts from "./RecommendedProducts.client"
import NoImage from '~/assets/no_image_big.jpg';
import { buttonBackToTop, multiStore, quantityCustom, sectionRecommendedProducts, setupSectionBelow } from "../../../../setup/settings/__product"
import ProductDescription from "../description/ProductDescription.client"
import NoImageMultiStore from '~/assets/missingImage.jpg';
import BackToTopButton from "~/rs-components/elements/BackToTop.client"
import SetupCustomSectionBelow from "../../../../setup/components/setup/productDetail/SetupCustomSectionBelow.client"

type ProductDetailsProps =
    {
        product: ProductMetafields,
        featuredProducts: ProductFilterObject[],
        shop: ShopMetafields,
        customer: CustomerMetafields,
        customerAccounts: CustomerAccount[],
    }

export default function ProductDetails({ product, featuredProducts, customer, customerAccounts, shop }: ProductDetailsProps) {
    const settings = shop.settings?.value ? shop.settings?.value : "[]";
    const currency = shop.moneyFormat;


    const variantStock = product.variants.edges.filter(variant => variant.node?.title != 'DefaultVariant' && variant.node?.showInProductPage?.value != 'false') as VariantEdgeMetafields[];
    const variantDefault = product.variants.edges.filter(variant => variant.node?.title == 'DefaultVariant') as VariantEdgeMetafields[];
    const minimumQuantity: number = quantityCustom.visible && product.minimumQuantity?.value != null ? parseInt(product.minimumQuantity?.value) : 1;
    const multiplierQuantity: number = quantityCustom.visible && product.multiplierQuantity?.value != null ? parseInt(product.multiplierQuantity?.value) : 1;
    const images: ImageItem[] = product.images?.value != null ? JSON.parse(product.images?.value) : [];
    const defaultImage = images != null && images.length > 0 ? images[0].Src : (multiStore ? NoImageMultiStore : NoImage);
    const [activeImage, setActiveImage] = useState<string>(defaultImage);
    const [selectedVariant, setSelectedVariant] = useState(variantStock[0]?.node.id);
    const [showCustomize, setShowCustomize] = useState(false);
    const [variant, setVariant] = useState<VariantEdgeMetafields | undefined>(undefined);
    const [modalType, setModalType] = useState<number>(0);
    const isStock: boolean = variantStock.length > 0;
    const shopSettings: ShopSettings = settings != null && settings != "" ? JSON.parse(settings) : JSON.parse("{}");

    useEffect(() => {
        if (showCustomize) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'auto';
    }, [showCustomize])

    useEffect(() => {
        setActiveImage(defaultImage)
    }, [defaultImage])

    const hideModal = () => {
        // document.body.style.overflow = 'unset';
        setShowCustomize(false);
    }

    const {
        isOpen: isCartOpen,
        openDrawer: openCart,
        closeDrawer: closeCart,
    } = useDrawer();

    const cart = useCart()

    const addVariantBasket = (variant: VariantEdgeMetafields) => {
        setSelectedVariant(variant.node.id);
        setShowCustomize(false);
        onAddToBasket(1);
    }

    const onAddToBasket = (quantity: number) => {
        const merchandiseId = selectedVariant ? `${selectedVariant}` : variantDefault[0]?.node.id;
        if (!quantityCustom.visible) {
            const line: CartLineInput = {
                merchandiseId,
                quantity: 1
            }
            cart.linesAdd([line])
            openCart();
        }
        if (quantityCustom.visible && quantity >= minimumQuantity && quantity % multiplierQuantity == 0) {
            const line: CartLineInput = {
                merchandiseId,
                quantity: quantity,
                attributes: [
                    {
                        key: "multiplierQuantity",
                        value: `${multiplierQuantity}`
                    },
                    {
                        key: "minimumQuantity",
                        value: `${minimumQuantity}`
                    }
                ]
            }
            cart.linesAdd([line])
            openCart();
        }
    }


    const [showImage, setShowImage] = useState(false);
    return (
        <>
            <ZoomImageModal showImage={showImage} setShowImage={setShowImage} activeImage={activeImage} />
            <CartDrawer isOpen={isCartOpen} onClose={closeCart} currency={currency} customerAccounts={customerAccounts} />
            <CustomizeModal
                currency={currency}
                addVariantBasket={addVariantBasket}
                variant={variant}
                product={product}
                show={showCustomize}
                close={hideModal}
                openCart={openCart}
                modalType={modalType}
                shopSettings={shopSettings}
            />
            <ProductsBreadcrumb className="breadcrumb px-5 marginProduct" />
            <div className="product-container container px-4">
                <div className="grid grid-cols-1 sm:grid-cols-2">
                    <ProductImage
                        setShowImage={setShowImage}
                        setActiveImage={setActiveImage}
                        images={images}
                        activeImage={activeImage}
                        product={product}
                    />
                    <ProductInfo
                        product={product}
                        shopSettings={shopSettings}
                        currency={currency}
                        setVariant={setVariant}
                        setShowCustomize={setShowCustomize}
                        setSelectedVariant={setSelectedVariant}
                        selectedVariant={selectedVariant}
                        onAddToBasket={onAddToBasket}
                        featuredProducts={featuredProducts}
                        show={showCustomize}
                        customer={customer}
                        setModalType={setModalType}
                        isStock={isStock}
                        variants={variantStock}
                        variantDefault={variantDefault}
                    />
                </div>
                <ProductDescription product={product} shopSettings={shopSettings}></ProductDescription>

                {buttonBackToTop.productDetailEnabled && <BackToTopButton />}

            </div>
            {sectionRecommendedProducts.enabled &&
                < div className="pre-footer mb-20">
                    {featuredProducts.length > 0 &&
                        <RecommendedProducts product={product} featuredProducts={featuredProducts} settings={settings} currency={currency} />
                    }
                </div >
            }
            {setupSectionBelow.enabled &&
                <SetupCustomSectionBelow shop={shop} brand={product.vendor} productRange={product.productType} />
            }
        </>
    )
}

const comments = () => {
    return (
        {
            /* 
                <div className="featured-product grid grid-cols-1 sm:grid-cols-2 my-10">
                    <div className="image-feature">
                        <img src="https://cdn.shopify.com/s/files/1/0600/3595/6902/files/image_7.jpg?v=1654192874" alt="" />
                    </div>
                    <div className="text-featured lg:pl-20 lg:pr-36 md:px-10 sm:px-10">
                        <p>Furniture Of Excellent Quality, That Make Your Home An Even Better Place</p>
                    </div>
                </div> 
            */
        }

    )
}